import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'


// Material helpers
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
// Component styles
import styles from './styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'
import { Button } from '@material-ui/core';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class PieStatistics extends Component {

    constructor(props) {
        super(props);
        //console.log(this.props.data.listItems)
        var cont=0
        var contType=0
        var colors=["#a79de7", "#63cbd3", "#fc7e81", "#ea4c88", "#434248", "#ad805a", "#ff5722", "#9c27b0"]
        var data=[]
        var data2=[]
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        Object.keys(this.props.data.listItems).map(datos=>{
            var color=colors[contType]
            var cantidadTipos=(this.props.data.listItems[datos].length)
            var newTableData=''
            var porcentType=0
            if(cantidadTipos>0){
                porcentType=parseFloat(cantidadTipos*100)/this.props.data.eleTotal
                porcentType=parseFloat(porcentType.toFixed(2))
                //newTableData+='<Table><TableRow><TableCell><Typography variant="h6">Porcentaje:'+porcentType+' %</Typography></TableCell></TableRow></Table>'
                //newTableData+='<Table><TableRow><TableCell><Typography variant="h4">TIPO</Typography></TableCell><TableCell><Typography variant="h4">ESTADO</Typography></TableCell></TableRow></Table>'
                newTableData+='<table><tr style="text-align:center"><td style="text-align:center;font-weight:bold"> '+ `${t('pie-statistics.table-data.percentage')} ` +porcentType+' %</td></tr></table>'
                newTableData+='<table style="border-collapse: collapse; border: 1px solid black;">'
                newTableData+=`<tr><td  style="border-collapse: collapse; border: 1px solid black;font-weight:bold;">${t('pie-statistics.table-data.type')}</td>`
                newTableData+=`<td  style="border-collapse: collapse; border: 1px solid black;font-weight:bold;">${t('pie-statistics.table-data.url')}</td>`
                newTableData+=`<td  style="border-collapse: collapse; border: 1px solid black; font-weight:bold;">${t('pie-statistics.table-data.status')}</td></tr>`
                Object.keys(this.props.data.listItems[datos]).map(tableData=>{
                    var newdataTable=(this.props.data.listItems[datos][tableData])
                    if(newdataTable.url.length>80){
                        newdataTable.url=newdataTable.url.substr(0,80)+'...'
                    }
                    if(newdataTable.tipo==="/"){
                        newdataTable.tipo="otros"
                    }
                    newTableData+='<tr><td  style="border-collapse: collapse; border: 1px solid black;">'+newdataTable.tipo+'</td>'
                    newTableData+='<td  style="border-collapse: collapse; border: 1px solid black;">'+newdataTable.url+'</td><td  style="border-collapse: collapse; border: 1px solid black;">'+newdataTable.estado+'</td></tr>'
                })
                newTableData+='</table>'

            }
            //console.log(newTableData)
            contType=contType+1
            data2.push({"name":datos, "y":porcentType, "color":color, "table":newTableData})
        })
        Object.keys(this.props.data.contador_tipos).map(types=>{
            var porcentType=parseFloat(this.props.data.contador_tipos[types]*100)/this.props.data.eleTotal
            
            //console.log(types, this.props.data.contador_tipos[types], this.props.data.eleTotal)
            if(types==="/"){
                types="otros"
            }
            porcentType=parseFloat(porcentType.toFixed(2))
            data.push({"name":types, "y":porcentType, "color":colors[cont]})
            //console.log(types, this.props.data.contador_tipos[types], cont, colors[cont])
            //console.log(colors[cont])
            cont=cont+1
        })
        //console.log(data)
        this.state = {
         chartData: {
            "title": t('pie-statistics.title.by-type'),
            "data": data,
          },
          chartData2: {
            "title": t('pie-statistics.title.by-status'),
            "data":data2
          },
        }
      }
      
      componentDidMount() {
        this.createChart();
        this.createChart2();
      }
      
      render() {
        const {classes}=this.props
        return (
            <Grid container direction="row" justify="center" alignItems="center" style={{backgroundColor:"white"}}>
                <Grid item  lg={12} xl={12} xs={12} id="hola" />
                <Grid item  lg={12} xl={12} xs={12}  id="hola2" />
            </Grid>
          
        )
      }

      createChart2 = () => {
        Highcharts.chart("hola2", {
            chart: {
                type: 'pie',
                options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
                },
            }, 
            title: { text: '' },
            subtitle: { text: '' },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    size: 200,
                },
            },
            legend: {
                title: {
                    text: this.state.chartData2.title,
                    style: {
                        font: 'Arial, Helvetica, sans-serif',
                        fontSize: 18,
                        width: 180,
                        lineHeight: 20,
                        color: '#333333',
                        fontWeight: 'normal'
                    },
                },
                align: 'left',
                verticalAlign: 'middle',
                layout: 'vertical',
                itemMarginTop: 2,
                itemMarginBottom: 2,
                itemStyle: {
                    fontSize: 14,
                    font: 'Arial, Helvetica, sans-serif',
                    color: '#333333',
                    fontWeight: 'normal'
                },
            },
            tooltip: {
                //valueSuffix: '%',
                useHTML: true,
                formatter: function() {
                    return this.point.table ;
                }
            },
            series:[{
                name: null,
                data: this.state.chartData2.data,
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }],
            responsive: {
                rules: [{
                    condition: { maxWidth: 420 },
                    chartOptions: {
                        legend: {
                            title: {
                                    style: {
                                    fontSize: 14,
                                    lineHeight: 16
                                }
                            },
                            align: 'center',
                            verticalAlign: 'top',
                            layout: 'horizontal',
                            itemDistance: 10,
                            maxHeight: 120,
                            itemStyle: {
                                fontSize: 12,
                            },
                        },
                    }
                }]
            },
            credits: {
                enabled: false
            },
        
        });
    }
      
    createChart = () => {
        Highcharts.chart("hola", {
            chart: {
                type: 'pie',
                options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
                },
            }, 
            title: { text: '' },
            subtitle: { text: '' },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    size: 200,
                },
            },
            legend: {
                title: {
                    text: this.state.chartData.title,
                    style: {
                        font: 'Arial, Helvetica, sans-serif',
                        fontSize: 18,
                        width: 180,
                        lineHeight: 20,
                        color: '#333333',
                        fontWeight: 'normal'
                    },
                },
                align: 'left',
                verticalAlign: 'middle',
                layout: 'vertical',
                itemMarginTop: 2,
                itemMarginBottom: 2,
                itemStyle: {
                    fontSize: 14,
                    font: 'Arial, Helvetica, sans-serif',
                    color: '#333333',
                    fontWeight: 'normal'
                },
            },
            tooltip: {
                valueSuffix: '%',
                useHTML: true,
                formatter: function() {
                    return this.point.name + ' : '+ this.y+'%';
                }
            },
            series:[{
                name: null,
                data: this.state.chartData.data,
                dataLabels: {
                    enabled: false
                },
                showInLegend: true
            }],
            responsive: {
                rules: [{
                    condition: { maxWidth: 420 },
                    chartOptions: {
                        legend: {
                            title: {
                                    style: {
                                    fontSize: 14,
                                    lineHeight: 16
                                }
                            },
                            align: 'center',
                            verticalAlign: 'top',
                            layout: 'horizontal',
                            itemDistance: 10,
                            maxHeight: 120,
                            itemStyle: {
                                fontSize: 12,
                            },
                        },
                    }
                }]
            },
            credits: {
                enabled: false
            },
        
        });
    }
}

export default compose(withStyles(styles), withTranslation())(PieStatistics);